import { RejectType } from '@uirouter/angularjs';
import { app } from '../../app';
import { resolve } from '../store';

app.run(init);

/** @ngInject */
function init($state, $transitions) {
    $transitions.onError({}, transition => {
        const isReloading = $state.current.abstract;
        const resolveFailed = transition.error().type === RejectType.ERROR;
        if (!isReloading || !resolveFailed) return;

        const isCompanyState = transition.to().name.startsWith('company.');
        const isAdmin = !!resolve.currentCompany;

        const state = isCompanyState && isAdmin ? 'company' : 'user';
        $state.go(state, transition.params());
    });
}



// WEBPACK FOOTER //
// ./src/portal/init/ui-router/handle-reload-error.js